import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { roleHasAccess } from '@rosita/shared';
import { useAppSettings } from '../../lib/appSettings';
import { useAuthStore } from '../../stores/authStore';
import MaintenancePage from '../../pages/public/MaintenancePage';

/**
 * When maintenance mode is ON, every visitor sees the maintenance page —
 * except logged-in staff (store_manager+), who keep full access so they can
 * keep working and turn it back off. The login route stays reachable so an
 * admin can authenticate during maintenance.
 */
export function MaintenanceGate({ children }: { children: ReactNode }): JSX.Element {
  const { maintenanceMode, maintenanceMessage } = useAppSettings();
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (!maintenanceMode) return <>{children}</>;

  const isStaff = user ? roleHasAccess(user.role, 'store_manager') : false;
  if (isStaff) return <>{children}</>;

  // Let admins reach the login screen to authenticate during maintenance.
  // Once they log in, the staff check above lets them back into the site.
  if (location.pathname.startsWith('/conta/login')) return <>{children}</>;

  return <MaintenancePage message={maintenanceMessage} />;
}
